import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { formatResourceName } from 'utils/formatResourceName';
import { LAUNDRY_BOOKINGS } from '../bookings';
import { LAUNDRY_SCHEDULES } from '../schedules';
import { NON_BOOKABLE_SLOTS } from '../non-bookable-slots';
import { LaundryBrikkModalContext } from '../../../components/brikks/home/LaundryService/components/LaundryBrikkModalContext';
import { BOOKING_HISTORY } from '../booking-history';
import { submitResourceBooking } from './api';
import { mapDataForBackend } from './mapData';
import { getErrorMessages } from './getErrorMessages';

export function useSubmitResourceBooking() {

  const { openModal } = useModal();
  const intl = useIntl();

  const queryClient = useQueryClient();
  const { selectedResource } = useContext(LaundryBrikkModalContext);

  const { mutate, isLoading, isSuccess, isError } = useMutation(
    (data) => submitResourceBooking(mapDataForBackend(data)),
    {
      onSuccess: () => {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'submitResourceSuccess',
          },
        });
        queryClient.invalidateQueries(LAUNDRY_BOOKINGS);
        queryClient.invalidateQueries(LAUNDRY_SCHEDULES);
        queryClient.invalidateQueries(NON_BOOKABLE_SLOTS);
        queryClient.invalidateQueries(BOOKING_HISTORY);
      },
      onError: (error) => {
        const description = getErrorMessages(error.errorMessage, {
          resource: formatResourceName(selectedResource && selectedResource.name, intl.locale),
        });
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: description && description.intl,
            intlValues: description && description.intlValues,
          },
        });
      },
    },
  );

  return {
    submitResourceBooking: mutate,
    isLoading,
    isSuccess,
    isError,
  };
}
